import React from 'react';
import { RecordingAsset } from 'types';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import { RAIL_PAGE_SIZE } from 'consts';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

import RailProvider from '../components/RailProvider/RailProvider';
import RailSkeleton from '../components/RailSkeleton/RailSkeleton';

import { RecordingRailContainer } from './components';
import { useRecordingRail } from './hooks';

interface Props {
  referenceId: string;
}

export function RecordingRail({ referenceId }: Props) {
  const { data, settings, isRailInvalid, handleSkeletonRef, shouldPreventDisplay, isLoading } = useRecordingRail(
    referenceId,
  );
  const type = UIDAPresentationTypeEnum.npvr;

  if (!settings || isRailInvalid) {
    return null;
  }

  if (shouldPreventDisplay || isLoading) {
    return (
      <RailSkeleton handleRef={handleSkeletonRef} settings={settings} numberOfCells={RAIL_PAGE_SIZE} shouldShowHeader />
    );
  }

  return (
    <WidgetProvider<RecordingAsset> type={type} settings={settings} data={data}>
      <RailProvider<RecordingAsset> referenceId={referenceId}>
        <RecordingRailContainer />
      </RailProvider>
    </WidgetProvider>
  );
}
